<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="group-list-list-view" class="data-list-container">
		<vs-table
			ref="table"
			v-model="selected"
			hoverFlat
			pagination
			:multiple="customConfig.rowSelectionMultiple"
			:max-items="itemsPerPage"
			:data="products"
		>
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-6">
				<vs-button
					v-if="!customConfig.btnAssigGroup"
					type="filled"
					class="g-btn-customize p-0 btnCustom"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="$emit('valueCreateGroup', 1)"
				>
					<span class="btnTextCustom">{{
						$t("Crud.Create") + " " + $t("New") + " " + $t("Groups.Group")
					}}</span>
				</vs-button>
				<div class="vx-row">
					<div class="vx-col pr-0">
						<label class="vs-input--label">{{ $t("SearchBy") }}</label>
						<v-select
							v-model="searchField"
							:clearable="false"
							:options="searchOptions"
							name="filter-selected"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:placeholder="$t('Search')"
							class="w-full"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
					</div>
					<div class="vx-col mt-6 pl-0">
						<div class="flex flex-wrap justify-start ml-2">
							<vs-input
								:placeholder="placeholderSearch"
								v-model="searchQuery"
								@keyup.enter="searchHandle"
							/>
							<vs-button
								:title="$t('Search')"
								class="ml-2"
								icon-pack="feather"
								icon="icon-search"
								@click="searchHandle"
							></vs-button>

							<vs-button
								:title="$t('Schedule.Refresh')"
								class="ml-2"
								icon-pack="feather"
								icon="icon-refresh-cw"
								@click="refresh"
							></vs-button>

							<vs-button
								v-if="customConfig.btnAssigGroup"
								@click="addGroupActivity"
								icon-pack="feather"
								icon="icon-plus"
								class="ml-2"
							>
								{{ $t("Groups.AssignGroups") }}
							</vs-button>
						</div>
					</div>
				</div>
			</div>
			<template slot="thead">
				<vs-th
					v-if="enableHeadTable('name')"
					class="g-table--title"
					sort-key="name"
					v-text="$t('Name')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('description')"
					class="g-table--title"
					sort-key="description"
					v-text="$t('Description')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('address')"
					class="g-table--title"
					sort-key="address"
					v-text="$t('Address')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('hour_init')"
					class="g-table--title truncate"
					sort-key="hour_init"
					v-text="$t('InitHour')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('hour_end')"
					class="g-table--title truncate"
					sort-key="hour_end"
					v-text="$t('EndHour')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('total_resource')"
					class="g-table--title"
					sort-key="hour_end"
					v-text="$t('Resource.Resources')"
				></vs-th>
				<vs-th v-if="enableHeadTable('action')" class="g-table--title" v-text="$t('Action')"></vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
						<vs-td v-if="enableHeadTable('name')">
							<p class="g-table--description truncate">
								{{ tr.name }}
							</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('description')">
							<p class="g-table--description">
								{{ tr.description | title }}
							</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('address')">
							<p class="g-table--description truncate">
								{{ (tr.city + " " + tr.address) | title }}
							</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('hour_init')">
							<p class="g-table--description">{{ tr.hour_init }}</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('hour_end')">
							<p class="g-table--description">{{ tr.hour_end }}</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('total_resource')">
							<p class="g-table--description">{{ tr.total_resource }}</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('action')" class="g-table--description whitespace-no-wrap">
							<feather-icon
								v-if="groupUpdatePermission"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								class="g-label--normal"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="groupDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="confirmDeleteGroup(tr)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<!-- ASSIGNED GROUPS -->
		<div class="text-right">
			<vs-button
				v-if="customConfig.btnAssigGroup"
				type="filled"
				class="g-btn--resourcePopup"
				@click.prevent="addGroupActivity"
			>
				{{ $t("Groups.AssignGroups") }}
			</vs-button>
		</div>
	</div>
</template>

<script>
import moduleGroup from "@/store/group/moduleGroup.js";
import Group from "@/models/Group.js";
import vSelect from "vue-select";

export default {
	components: {
		vSelect,
	},
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssigGroup: false,
					columns: ["name", "description", "address", "hour_init", "hour_end", "total_resource", "action"],
					rowSelectionMultiple: true,
				};
			},
		},
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 5,
			isMounted: false,
			addNewDataSidebar: false,
			currentPageLocal: 1,
			quantityElementPage: 10,
			groupDelete: null,
			sidebarData: {},
			searchQuery: "",
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			searchField: {value: "name", label: this.$t("Name")},
		};
	},
	watch: {
		itemsPerPage(val) {
			this.getGroups({page: 1, quantity: val});
			this.currentPageLocal = 1;
		},
		currentPage(val) {
			this.getGroups({page: val, quantity: this.itemsPerPage});
		},
		searchField(val) {
			this.searchQuery = "";
		},
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		products() {
			return this.$store.state.moduleGroup.groups;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length;
		},
		groupUpdatePermission() {
			return this.$store.getters.checkPermission("GROUPS_U");
		},
		groupDeletePermission() {
			return this.$store.getters.checkPermission("GROUPS_D");
		},
		searchOptions() {
			return [
				{value: "name", label: this.$t("Name")},
				{value: "city", label: this.$t("City")},
				{value: "hour_init", label: this.$t("InitHour")},
				{value: "hour_end", label: this.$t("EndHour")},
			];
		},
		placeholderSearch() {
			// validate if searchField is hours then return the placeholder with the format of the hours 08:00:00
			if (this.searchField.value === "hour_init" || this.searchField.value === "hour_end") {
				return this.$t("Search") + " " + this.searchField.label + " (HH:mm:ss)";
			}
			return this.$t("Search") + " " + this.searchField.label;
		},
	},
	methods: {
		enableHeadTable(headName) {
			return this.customConfig.columns.includes(headName);
		},
		// Este metodo se utiliza cuando el componente esta mondato desde el componente de actividades
		addGroupActivity() {
			if (!this.customConfig.rowSelectionMultiple) {
				this.$store.commit("moduleGroup/CLEAN_GROUP_ACTIVITY");
			}
			this.$store.dispatch("moduleGroup/addGroupActivity", this.selected);
			this.$emit("showPopupEmmit", false);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getGroups({page, quantity}) {
			this.openLoading();
			const payload = {
				page,
				quantity,
			};
			if (this.searchQuery) {
				payload[this.searchField.value] = this.searchQuery;
			}
			this.$store
				.dispatch("moduleGroup/fetchGroupItems", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					this.closeLoading();
				})
				.catch((error) => {
					this.closeLoading();
					if (error.status === 722) {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Permissions.RequiredPermissions"),
							text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
							time: 6000,
							icon: "lock",
						});
					}
					throw new Error(error);
				});
		},
		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},
		confirmDeleteGroup(data) {
			this.groupDelete = data;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteGroup.Text1") + ` "${this.groupDelete.name}"? ` + this.$t("DeleteGroup.Text2"),
				accept: this.deleteGroup,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteGroup() {
			this.openLoading();
			this.$store
				.dispatch("moduleGroup/removeGroup", this.groupDelete.id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmGroupDelete"),
						text: this.$t("TextConfirmGroupDelete"),
					});
				})
				.catch((err) => {
					throw new Error(err);
				})
				.finally(() => {
					this.closeLoading();
				});
		},
		editData(data) {
			this.$emit("selectedGroupEmit", new Group(data));
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		cahngeCurrentPageLocal() {
			this.currentPageLocal = 1;
			this.getGroups({page: val, quantity: this.itemsPerPage});
		},
		searchHandle() {
			this.getGroups({page: 1, quantity: this.itemsPerPage});
		},
		refresh() {
			this.searchQuery = "";
			this.searchField = this.searchOptions[0];
			this.getGroups({page: 1, quantity: this.itemsPerPage});
		},
	},
	created() {
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
		this.getGroups({page: "", quantity: 5});
	},
	mounted() {
		this.isMounted = true;
		const popup = document.querySelector(".vs-popup");
		if (popup !== null) popup.setAttribute("style", "width: 73%");
	},
};
</script>

<style lang="scss" scoped>
#group-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
